import React from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

function ModalCreateUpdate({
	selectedItem,
	setSelectedItem,
	createUpdate,
	modalCreateUpdate,
	toggleModalCreateUpdate,
}) {
	const { t } = useTranslation()

	return (
		<Modal show={modalCreateUpdate} animation={false} centered
			size="md" dialogClassName="update-modal-width"
			onHide={() => toggleModalCreateUpdate()}>
			<Modal.Header closeButton>
				<Modal.Title>
					{!selectedItem.id ? t('create') : t('edit')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={createUpdate} autoComplete="off">
					<div className="form-group">
						<label>{t('name2')}</label>
						<input type="text" className="form-control" name="name"
							value={selectedItem.name ?? ''}
							autoFocus
							onChange={(e) => setSelectedItem({ ...selectedItem, name: e.target.value })} />
					</div>

					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleModalCreateUpdate()}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100">
							{t('save')}
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	)
}

export default ModalCreateUpdate
